export const effortValidatorFunc = value => {
  return (
    (/^\s*-?(\d+(\.\d{1,2})?|\.\d{1,2})\s*$/.test(value) &&
      (parseFloat(value) >= 0 && parseFloat(value) <= 100)) ||
    value === '' ||
    typeof value === 'undefined'
  );
};
